<template>
  <div class="pc-search">
    <el-form :model="keywordData" :inline="true">
      <el-form-item label="用户名" class="title">
        <el-input
          v-model="keywordData.username"
          placeholder="请输入用户名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="用户ID" class="title">
        <el-input
          v-model="keywordData.user_id"
          placeholder="请输入用户ID"
          clearable
        ></el-input>
      </el-form-item>

      <br />

      <el-form-item label="注册时间" class="updateTime">
        <el-date-picker
          v-model="keywordData.register_time"
          type="daterange"
          clearable
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="登录时间" class="updateTime">
        <el-date-picker
          v-model="keywordData.login_time"
          type="daterange"
          clearable
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      keywordData: {
        username: "",
        user_id: null,
        login_time: [],
        register_time: [],
      },
    };
  },
  methods: {
    search() {
      console.log(this.keywordData);
      this.$emit("search", this.keywordData);
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-search {
  @include table-search;
  padding-bottom: 20px;
  border-bottom: 1px solid $border-color;
  margin-bottom: 20px;
  .title {
    width: 400px;
  }
  .type {
    width: 300px;
  }
  .keyword {
    width: 400px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .number {
    width: 300px;
    /deep/ .el-input-number {
      width: 190px;
    }
  }
  .topic {
    width: 300px;
  }
  .status {
    width: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userList/UserSearch.vue